import type { ReactNode } from "react";
import Header from "@/components/public/Header";
import { cn } from "@/utils/common.utils";

interface DetailShellProps {
  children?: ReactNode;
  className?: string;
  main?: boolean;
  embedded?: boolean;
}

export default function DetailShell({ children, className, main = false, embedded = false }: DetailShellProps) {
  if (embedded) return <>{children}</>;
  const Wrapper = main ? "main" : "div";
  return (
    <div className={cn("min-h-screen bg-linen", className)}>
      <Header />
      <Wrapper>{children}</Wrapper>
    </div>
  );
}
